/**
 * Creates a FormData object with files and data values.
 * This eliminates code duplication between different invoice config files.
 * @function
 * @param {Array} filesList - List of files to append to FormData.
 * @param {Object} data - Data object to stringify and append to FormData.
 * @returns {FormData} FormData object with files and data values.
 */
export const createFormDataWithFiles = (filesList, data) => {
  const formData = new FormData();
  if (filesList.length) {
    filesList.forEach((file) => {
      formData.append('files_metadata', file);
    });
  }

  const newData = {
    ...data,
    wordings: data.wordings && Object.values(data.wordings)
  };

  formData.append('values', JSON.stringify(newData));

  return formData;
};
